import { render } from "./UserManagementView.vue?vue&type=template&id=23e38c49&scoped=true"
import script from "./UserManagementView.vue?vue&type=script&lang=js"
export * from "./UserManagementView.vue?vue&type=script&lang=js"

import "./UserManagementView.vue?vue&type=style&index=0&id=23e38c49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e38c49"]])

export default __exports__